<template>
	<div style="background-color: #f2f2f4;min-height: 100%;">
	  <Header title="重修选课记录" type="0" route="/homeIndex"></Header>
    <div class="contentDiv">
      <div class="list-xq">
			<span @click="xqChang()">{{cxxq}}学期</span>
		</div>
	  <div class="teachingProcess">
		<div class="list-head">
			<p>{{baseData.cxxq}}学期</p>
			<ul class="timeCss">
				<li><label>报名截止时间：{{baseData.bmkssj}}~{{baseData.bmjssj}}</label></li>
				<li><label>选课截止时间：{{baseData.xkkssj}}~{{baseData.xkjssj}}</label></li>
			</ul>
		</div>
		<NOdata
		  title="暂无数据~"
		  v-if="this.pageData && this.pageData.length == 0"
		></NOdata>
		<div class="content">
		  <div class="contentDiv" style="background-color: #fff"  v-for="(item, index) in pageData" :key="index"  @click="showDetal(item)">
			<span class="xkspan" v-if="item.xkover=='1'">已选课</span>
			<span class="bmspan" v-else-if="item.bmover=='1'">已报名</span>
			<p>{{ item.kcmc }}</p>
			<ul>
			  <li>开课单位：{{ item.kkdw }}</li>
			  <li>重修报名类别：{{ item.kcsxname }}</li>
			</ul>
			<div class="xkrsmsgdiv">
				<div style="padding:0px;margin:0px">
					<div style="margin:0px;padding:0px;float: left;width: 50%;">上课人数：{{item.xkrs}}</div>
				    <div style="margin:0px;padding:0px;float: left;width: 50%;">排课人数：{{item.pkrs}}</div>
				</div>
				<div style="padding:0px;margin:0px">
					<div style="margin:0px;padding:0px;float: left;width: 50%;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">开课院系：{{item.kkdw}}</div>
				    <div style="margin:0px;padding:0px;float: left;width: 50%;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">上课校区：{{item.skxq}}</div>
				</div>
				<div style="padding:0px;margin:0px">
					<div style="margin:0px;padding:0px;float: left;width: 50%;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">上课时间：{{item.sktime}}</div>
				    <div style="margin:0px;padding:0px;float: left;width: 50%;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">上课地点：{{item.skaddr}}</div>
				</div>
				<div style="padding:0px;margin:0px">
					<div style="margin:0px;padding:0px;float: left;width: 50%;">学时：{{item.zxs}}</div>
				    <div style="margin:0px;padding:0px;float: left;width: 50%;">学分：{{item.xf}}</div>
				</div>
				<div style="padding:0px;margin:0px">
					<div style="margin:0px;padding:0px;float: left;width: 50%;">性别要求：{{item.xbyq}}</div>
				    <div style="margin:0px;padding:0px;float: left;width: 50%;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">分组名称：{{item.fzmc}}</div>
				</div>
			
			</div>
		</div>
    <div style="height: 50px;">

    </div>
		  </div>
		 
	  </div>
    </div>
    
	  <van-tabbar
      class="bottom-nav"
      v-model="active"
      active-color="#7469F8"
      inactive-color="#B3B9D0"
      route
    >
      <van-tabbar-item class="van-icon-like-o" replace to="/student/cxCuarChoose">
        <span class="nav-title">报名选课</span>
      </van-tabbar-item>
      <van-tabbar-item class="van-icon-like" replace to="/student/cxCuarChooseHistory">
        <span class="nav-title">选课记录</span>
      </van-tabbar-item>
    </van-tabbar>
    <van-popup v-model="show" round position="bottom">
      <van-picker
        :title=title
        show-toolbar
        :default-index="defultIndex"
        :columns="cloumList"
        @cancel="show = false"
        @confirm="
          (value, index) => {
            onConfirm(value, index);
          }
        "
    /></van-popup>
	<van-popup v-model="detalShow" class="popup">
	 <h2>{{this.curItem.kcmc}}</h2>
	  <p>上课老师：<span>{{this.curItem.teachername}}</span></p>
      <p>上课班级：<span>{{this.curItem.ktmc}}</span></p>
      <p>上课人数：<span>{{this.curItem.xkrs}}</span></p>
      <p>排课人数：<span>{{this.curItem.pkrs}}</span></p>
      <p>开课院系：<span>{{this.curItem.kkdw}}</span></p>
      <p>上课校区：<span>{{this.curItem.skxq}}</span></p>
      <p>上课时间：<span>{{this.curItem.sktime}}</span></p>
      <p>上课地点：<span>{{this.curItem.skaddr}}</span></p>
      <p>学时：<span>{{this.curItem.zxs}}</span></p>
      <p>学分：<span>{{this.curItem.xf}}</span></p>
	  <p>性别要求：<span>{{this.curItem.xbyq}}</span></p>
	  <p>分组名称：<span>{{this.curItem.fzmc}}</span></p>
      <button @click="detalShow=false">知道了</button>
    </van-popup>
	</div>
  </template>
  
  <script>
  import { Api } from "@/utils/axios";
  export default {
	data() {
	  return {
		pageData: [],
		active: 0,
		title: "重修学期",
		show: false,
		cloumList:[],
		baseData:{},
		cxxq:'',
		conperType :'',
		messageTittle:'',
		tzdid:'',
		message:'',
		detalShow:false,
    defultIndex:0,
	curItem:{}
	  };
	},
	methods: {
    xqChang(){
			this.show = true;
		},
		onConfirm(item,index){
      if(this.cxxq!=item.value){
        this.cxxq = item.value;
        this.initData();
      }
		  
			this.show = false;
		},
	  async initData(){
      const params = {
        cxxnxq:this.cxxq
      };
      const res = await Api.cxXkKc_queryHistory(params);
      if (res.code == '1') {
        this.pageData = res.data
        if(res.heardData){
           this.baseData = res.heardData;
           if(this.baseData.cxxq&&this.baseData.cxxq!=''){
            this.cxxq = this.baseData.cxxq;
           }
        }
        if(res.xnxqData){
           for(let i=0;i<res.xnxqData.length;i++){
              let obj = {};
              obj.text = res.xnxqData[i].semesterName;
              obj.value = res.xnxqData[i].semesterId;
              if(obj.value==this.cxxq){
                this.defultIndex = i;
              }
              this.cloumList.push(obj);
           }
        }
      } else {
        this.$toast(res.Msg)
      }
		},

		showDetal(item){
			this.detalShow = true;
			this.curItem = item;
		}

	},
	created() {
		this.initData();
	}
  };
  </script>
  <style scoped lang="less" >
   .eva-body{overflow: auto;height: calc(~"100vh - 150px");}
  .teachingProcess {
	padding: 3% 5% 0;
	background-color: #f2f2f4;
  min-height: 100%;
	.list-head {
	  height: 90px;
	  background-image: url('~@/assets/images/assessment/cell--bg.png'), linear-gradient(0deg, #7368ff 0%, #8e85ff 100%);
	  background-size: 100% 100%;
	  background-repeat: no-repeat;
	  display: flex;
	  padding: 3% 5%;
	  box-sizing: border-box;
	  position: relative;
	  flex-direction: column;
	  border-radius: 8px;
      box-shadow: 0 2px 10px 0 #3323ff59;
	  p {
		height: 14px;
		font-family: PingFangSC-Medium;
		font-size: 14px;
		color: #fff;
		letter-spacing: 0;
		font-weight: lighter;
		margin-bottom: 10px;
	  }
	}
  
	.timeCss{
		ul{
         list-style:none;
		 padding: 0;
		 font-family: PingFangSC-Medium;
         font-size: 13px;
		 font-weight: lighter;
		 margin-top:10px ;
	  }
	  li{
		//display: inline-block;
		position: relative;
		color: #ffffff;
		font-family: PingFangSC-Medium;
         font-size: 10px;
		 font-weight: lighter;
		 label{
			padding-left:12px;
		 }
		 margin-bottom: 5px;
	  }
	  li:before{
		content: '';
		position: absolute;
		left: 3px;
		top: 50%;
		-webkit-transform:translateY(-50%) ;
		transform: translateY(-50%);
		width: 7px;
		height: 7px;
		border-radius: 50%;
		background-color: #fff;
	  }
	  li:first{
		
	  }
	  li:first-child:after{
		content: '';
		position: absolute;
		left: 6px;
		top: 10px;
		bottom: 0;
		height: 18px;
		width: 1px;
		
		border-left: 1px solid #fff;
	  }
	}

	.content {
		margin-top: 10px;
	  div {
		background: #f2f2f4;
		border-radius: 5px;
		padding: 3% 0 3% 6%;
		margin-bottom: 5%;
    position: relative;
  
		p {
		  height: 22px;
		  font-family: PingFangSC-SNaNpxibold;
		  font-size: 16px;
		  color: #333333;
		  letter-spacing: 0;
		  font-weight: 600;
		  margin-bottom: 2%;
		}
  
		ul li {
		  height: auto;
		  font-family: PingFangSC-Regular;
		  font-size: 14px;
		  color: #666666;
		  letter-spacing: 0;
		  margin-bottom: 1%;
		  font-weight: 400;
		}
		span {
		  position: absolute;
		  top: 0px;
		  right: 0px;
		  display: block;
		  width: 56px;
		  height: 24px;
		  border-radius: 0 8px 0 8px ;
		  font-size: 14px;
		  line-height: 20px;
		  padding-top: 2px;
		  padding-left: 10px;
		}
		.bmspan{
			background: #41b29c26;
			color: #41B29C;
		}
		.xkspan{
			background: #b26e4142;
			color: red;
		}
	  }
	}
	
  }
  .more.van-popup.van-popup--bottom {
	border-radius: 0 !important ;
  }
  .more {
	padding: 5% 0 5% 0;
	box-sizing: border-box;
	overflow: hidden;
	.van-tabs__content--animated {
	  height: 75vh;
	  overflow: auto;
	}
	.van-tabs--line .van-tabs__wrap {
	  border-bottom: 1px solid #f4f4f4;
	  .van-tab--active {
		.van-tab__text--ellipsis {
		  color: #212f6e !important;
		}
	  }
	  .van-tab__text--ellipsis {
		height: 20px;
		font-family: PingFangSC-Medium;
		font-size: 14px;
		color: #8f95b5;
		text-align: center;
		letter-spacing: 0;
	  }
	  .van-tabs__line {
		background-color: #7469f8 !important;
		width: 25px;
		height: 3px;
		border-radius: 1.5px;
	  }
	}
	& > p {
	  width: 64px;
	  font-weight: bolder;
	  font-family: PingFangSC-Medium;
	  font-size: 16px;
	  color: #000000;
	  letter-spacing: 0;
	  text-align: center;
	  padding-left: 7%;
	}
	ul {
	  overflow: auto;
	  height: 36vh;
	  .choose {
		background-color: #f2f2f4;
	  }
	  li {
		height: 40px;
		font-family: PingFangSC-Medium;
		font-size: 14px;
		color: #212f6e;
		font-weight: bold;
		display: flex;
		align-items: center;
		padding-right: 5%;
		padding-left: 7%;
		justify-content: space-between;
	  }
	}
  }

  .contentDiv{
		background-color: #fff;
	}
	.xkrsmsgdiv{
		margin-right:6% ;
		margin-top: 10px;
		height: 105px;
		font-family: PingFangSC-Regular;
		  font-size: 14px;
		  color: #666666;
		  letter-spacing: 0;
		  font-weight: 400;
	}
	.lrbutomdiv{
		background-color: #7469f8;
		height: 30px;width: 80px;
		line-height: 30px;
		border-radius: 16px;
		color: #fff;
		padding: 0;
		text-align: center;
		margin-left: calc(100%-80px);
		
	}

	/deep/.wpjs-detail-message-box {
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 14px;

  .red {
    color: red;
  }
}

.list-xq{
    height: 40px;
	  background-size: 100% 100%;
	  background-repeat: no-repeat;
	  display: flex;
	  padding: 3% 5%;
	  box-sizing: border-box;
	  flex-direction: column;
	  background-color: #fff;
	  width: 100%;
	  border-top: 1px solid #f2f2f4;
	  margin: auto;
	  text-align: center;
  }

.bottom-nav {
  .van-icon-like,
  .van-icon-like-o {
    font-family: "iconfont" !important;
    font-size: 19px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .van-tabbar-item__text{
	margin: 0;
	span{
		font-size: 14px;
		
	}
  }
  .van-icon-like::before {
    content: "\e6b7";
  }
  .van-icon-like-o::before {
    content: "\e6c0";
  }

}

.van-popup.van-popup--center{box-sizing: border-box;padding: 20px;}
.van-popup.van-popup--center>div{color: @attendance-background-color-1;font-size: 24px;font-weight: bold;text-align: center;padding-top: 10px;padding-bottom: 10px;}
  .van-popup.van-popup--center>p{
	color: @attendance-color-1;
	line-height: 30px;
	font-family: PingFangSC-SNaNpxibold;
	font-size: 16px;
	letter-spacing: 0;
	font-weight: 600;
}
  .van-popup.van-popup--center>p>span{
	font-family: PingFangSC-SNaNpxibold;
	font-size: 14px;
	letter-spacing: 0;
	font-weight: bold;
}
  .popup button{background-color: @attendance-background-color-7;color: @attendance-background-color-1;padding: 11px 0;border-radius: 3px;width: 100%;margin-top: 30px;}
  .van-popup--center{width: 90%;border-radius: 5px;}
  .van-popup.van-popup--center>h2{color: @attendance-color-1;font-size: 16px;line-height: 25px;text-align: center;font-weight: bold;}
  </style>
  


// WEBPACK FOOTER //
// src/components/student/cxCuarChoose/cxCuarChooseHistory.vue